import React, { useEffect, useState } from 'react';
import ElasticSearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  PagingInfo,
  Results,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch,
} from '@elastic/react-search-ui';
import {
  Layout,
} from '@elastic/react-search-ui-views';
import JobCardList from '../job/JobCardList';
import { JobResult } from '../types/job';
import SearchHeader from '../header/SearchHeader';
import MobileFilterMenu from '../mobile/MobileFilterMenu';
import FilterSummary from '../facet/FilterSummary';

// import moment from "moment";

import CustomPaginationView from '../pagination/CustomPaginationView';
import { MobileSearchProvider } from '../mobile/MobileSearchContext';

import FacetContainer from '../customFacet';
import { ElasticResultsWrapper } from '../job/ElasticResultsWrapper';
// Common Elasticsearch API settings
const ELASTIC_CONFIG = {
  host: 'https://5d0493d4cacf44dbb8a0b25eefe15970.us-east-2.aws.elastic-cloud.com:443',
  apiKey: 'X1NVQ1E1Z0I2ZkxkWlpmbzBzN1A6QnpkM1dYazRTVjZ3aUZqR0F1dG1NUQ==',
  jobsIndex: 'jobs-north-america',
};

// Elasticsearch Connector for job listings
const connector = new ElasticSearchAPIConnector({
  host: ELASTIC_CONFIG.host,
  index: ELASTIC_CONFIG.jobsIndex,
  apiKey: ELASTIC_CONFIG.apiKey,
});

const config = {
  searchQuery: {
    search_fields: {
      job_title: {
        weight: 3,
      },
      job_description: {},
      location: {},
      client_description: {},
    },
    result_fields: {
      job_title: {
        raw: {},
      },
      job_description: {
        snippet: {},
      },
      location: {
        raw: {},
      },
      salary: {
        raw: {},
      },
      job_id: {
        raw: {},
      },
      posted_date: {
        raw: {},
      },
      offsite_preference_name: {
        raw: {},
      },
    },
    disjunctiveFacets: [
      'markets.enum',
      'global_filter_category.enum',
      'placement_types.enum',
      'offsite_pref_filter_option.enum',
    ],
    facets: {
      'markets.enum': { type: 'value' },
      'global_filter_category.enum': { type: 'value', size: 1000 },
      'placement_types.enum': { type: 'value' },
      'offsite_pref_filter_option.enum': { type: 'value' },
    },
  },
  autocompleteQuery: {
    results: {
      resultsPerPage: 5,
      search_fields: {
        job_title: {
          weight: 3,
        },
      },
      result_fields: {
        job_title: {
          snippet: {
            size: 100,
            fallback: true,
          },
        },
      },
    },
  },
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true,
};

const JobListingMain = () => (
    <SearchProvider config={config}>
      <MobileSearchProvider>
      <WithSearch mapContextToProps={({
        resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
      }) => ({
        resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
      })}>
        {({
          resultsPerPage, setResultsPerPage, setSearchTerm, searchTerm,
        }) => {
          React.useEffect(() => {
            if (resultsPerPage !== 12) {
              setResultsPerPage(12);
            }
          }, [resultsPerPage, setResultsPerPage]);

          return (
            <div className="job-search">
              <SearchHeader setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
              <ErrorBoundary>

                <Layout
                  header={<MobileFilterMenu />}
                  sideContent={

                    <div className="job-listing-sidebar">
                      <FilterSummary />
                      <FacetContainer key={'2'} field={'placement_types.enum'} label={'Placement type'} />
                      <FacetContainer key={'4'} field={'offsite_pref_filter_option.enum'} label={'Location preference'} />
                      <FacetContainer key={'1'} field={'markets.enum'} label={'Location'} />
                    </div>
                  }
                  bodyHeader={
                    <div className="job-listing-body-header" id="job-listing">
                      <WithSearch mapContextToProps={({ totalResults }) => ({ totalResults })}>
                        {({ totalResults }) => (
                          totalResults > 0 ? (
                            <div className="job-results-count">
                              {totalResults} Results
                            </div>
                          ) : null
                        )}
                      </WithSearch>
                    </div>
                  }
                  bodyContent={
                  <div className="job-listing-body-results">
                    <ElasticResultsWrapper />
                  </div>
                  }
                  bodyFooter={
                    <div className="job-listing-body-footer">
                      <CustomPaginationView pagingContainer="test"/>
                    </div>
                  }
                />
              </ErrorBoundary>
            </div>
          );
        }}

      </WithSearch>
      </MobileSearchProvider>
    </SearchProvider>
);

export { JobListingMain };
